import { FC } from 'react'
import TSvgProps from './type/svgPropsType'

const PredictionArrow: FC<TSvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      {...props}
    >
      <desc>오른쪽 화살표</desc>
      <path fill="none" d="M0 0h17v17H0z" data-name="사각형 30017"></path>
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M6.78 4.287l4.984 4.984-4.984 4.984"
        data-name="패스 15793"
      ></path>
    </svg>
  )
}

export default PredictionArrow
